export interface ToniAIEmailRequest {
  question: string;
  thread_id: string;
  email_title: string;
  email_body: string;
}

export interface ToniAIEmailResponse {
  thread_id: string;
  chunk: string;
  is_complete: boolean;
  structured_output: ToniAIEmailResponseStructuredOutput;
}

export interface ToniAIEmailResponseStructuredOutput {
  preamble: string;
  title: string;
  body: string;
  postamble: string;
  complete_message: string;
}

export enum ToniAIMessageType {
  INCOMING = 'INCOMING',
  OUTGOING = 'OUTGOING',
}
export interface ToniAIMessageItem {
  type: ToniAIMessageType;
  time: Date;
  incoming?: ToniAIEmailResponse;
  outgoing?: ToniAIEmailRequest;
}
